import {
  Component,
  ViewEncapsulation,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-risk-indicator-card",
  templateUrl: "./risk-indicator-card.component.html",
  styleUrls: ["./risk-indicator-card.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RiskIndicatorCardComponent {
  env: any = environment;

  @Input() id: string;
  @Input() name: string;
  @Input() description: string;
  @Input() median: number;
  @Input() average: number;

  @Output() deleteClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/risk-indicator-card/risk-indicator-card.component.ts